import { render, staticRenderFns } from "./RemoveLiquidity.vue?vue&type=template&id=6d8da489&"
import script from "./RemoveLiquidity.vue?vue&type=script&lang=js&"
export * from "./RemoveLiquidity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports